<template>
  <div class="tabs-wrap clearfix">
    <div class="left f-left" :style="{width:showZixun?'100%':''}">
      <CourseShowTeacher :teachers="teachers" v-if="course.course_type  ==1"></CourseShowTeacher>
      <CourseShowTeacher_zj :teaching="teaching" v-else></CourseShowTeacher_zj>
      <div class="course-tabs-wrap">
        <BlockTabs
          :items="tabs"
          currentClass="bold5"
          isNew
          @changeTab="changeTab"
        ></BlockTabs>
        <Rich
          id="course-detail"
          class="tab-content-detail"
          v-html="course.course_details"
          v-if="currentTab == 1"
          oncontextmenu="return false"
          onselectstart="return false"
        ></Rich>
        <Empty
          class="empty"
          v-if="course.course_details == '' && currentTab == 1"
          title="暂无课程介绍信息！"
        />
        <div
          id="course-chapter"
          class="tab-content-plan"
          v-show="currentTab == 2"
        >
          <CourseChapter
            :course="course"
            @chapterClick="onChapterClick"
          ></CourseChapter>
        </div>
        <CourseCert
          ref="cert"
          v-show="currentTab == 4"
          :url="'/api/app/cert/course/' + course.id"
          style="padding-top: 10px"
        ></CourseCert>
        <div v-show="currentTab == 3" class="tab-content-comment">
          <CourseComment
            :courseId="course.id"
            @complaint="id => $refs.complaint.show(1, id)"
            @load="onCommentLoad"
          ></CourseComment>
        </div>
        <div v-show="currentTab == 5" class="tab-content-exam">
          <CourseExam
            :courseId="course.id"
            v-for="exam in exams"
            :key="exam.id"
            :exam="exam"
          ></CourseExam>
          <Empty
            class="empty"
            v-if="exams.length == 0"
            title="暂无课程考试信息哦！"
          />
        </div>
      </div>
    </div>
    <CourseShowRecommend
      v-if="!showZixun"
      :recommendCourses="recommendCourses"
    ></CourseShowRecommend>
    <Complaint ref="complaint"></Complaint>
  </div>
</template>
<script>
import CourseChapter from "../CourseChapter.vue";
import CourseComment from "../CourseComment.vue";
import CourseShowTeacher from "./CourseShowTeacher.vue";
import CourseShowRecommend from "./CourseShowRecommend.vue";
import Complaint from "@/components/community/components/Complaint.vue";
import CourseCert from "./CourseCert.vue";
import CourseExam from "../CourseExam.vue";
import CourseShowTeacher_zj from "./CourseShowTeacher_zj.vue";

export default {
  name: "CourseShowTabs",
  components: {
    CourseChapter,
    CourseComment,
    CourseShowTeacher,
    CourseShowRecommend,
    Complaint,
    CourseCert,
    CourseExam,
    CourseShowTeacher_zj,
  },
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    teachers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    teaching: {
      type: Array,
      default: () => {
        return [];
      },
    },

    teaching_zj: {
      type: Array,
      default: () => {
        return [];
      },
    },
    recommendCourses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    exams: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    currentTab(newValue) {
      if (newValue == 4) {
        this.$refs.cert.searchRefresh();
      }
    },
  },
  data() {
    return {
      currentTab: "1",
      commentTotal: 0,
      course_classify_id:0,

      showZixun:false
    };
  },
  computed: {
    tabs() {
      let tabs = [{ id: 1, name: "课程介绍" }];
      tabs.push({ id: 2, name: "课程大纲" });
      if (
        this.course.cert == 1 &&
        this.$store.state.commonSetting.switch_cert_module == 1
      ) {
        tabs.push({ id: 4, name: "课程证书" });
      }
      tabs.push({ id: 3, name: "课程评价 (" + this.commentTotal + ")" });
      if (this.exams.length > 0) {
        tabs.push({ id: 5, name: "课程考试" });
      }
      return tabs;
    },
  },
  created(){
    this.get_course_classify_id()
    this.$set(this.course,'course_details',this.replaceWhite(this.course.course_details))
  },  
  methods: {
    replaceWhite(html) { // 处理富文本默认图片，视频大小
      if(!html) return
              let newContent = html.replace(/<video[^>]*>/gi, function(match, capture) {
                      match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
                      match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
                      match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
                      return match;
              }).replace(/<img[^>]*>/gi, function(match, capture) {
                      match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
                      match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
                      match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
                      return match;
              });
              newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
                      match = match.replace(/width:[^;]+;/gi, 'max-width:100%;width:100%;').replace(/width:[^;]+;/gi,
                              'max-width:100%;width:100%;');
                      return match;
              });
              newContent = newContent.replace(/<br[^>]*\/>/gi, '');
              newContent = newContent.replace(/\<video/gi,
                      '<video style="max-width:100%;width:100%;;height:auto;display:inline-block;margin:10rpx auto;"').replace(/\<img/gi,
                      '<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;width:100%;"');
              return newContent;
      },
    get_course_classify_id(){
      process.env.BUILD_ENV == "test"  ? sessionStorage.setItem('course_classify_id',29) : sessionStorage.setItem('course_classify_id',19)

     
      const course_classify_id = sessionStorage.getItem('course_classify_id')

      if(course_classify_id == this.course.course_classify_id){
        this.showZixun = true
      }
       console.log(process.env.BUILD_ENV,this.showZixun)
    },
    changeTab(item) {
      this.currentTab = item.id;
    },
    onChapterClick(id) {
      this.$nextTick(() => {
        let offset = window.$("#chapter-" + id).offset();
        let top = offset.top - 84;
        window.$(document.documentElement).scrollTop(top);
      });
    },
    onCommentDelete() {
      this.$emit("commentDelete");
    },
    onCommentLoad({ total }) {
      this.commentTotal = total || 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs-wrap {
  margin-bottom: 70px;
  .left {
    width: calc(100% - 298px - 20px)
  }
}

.course-tabs-wrap {
  background: white;
  border-radius: 5px;
  padding-top: 12px;

  /deep/ {
    .tabs,
    .tab-item {
      border-radius: 5px;
    }
    .tab-item {
      margin-right: 0 !important;
      width: 124px !important;
    }
    .el-tabs__header {
      margin-bottom: 0;
    }
  }

  .empty,
  .tab-content-comment {
    border-radius: 15px;
  }

  .tab-content-detail {
    padding: 32px;
  }

  .tab-content-comment {
    padding: 0 32px 16px 32px;
  }
  .tab-content-exam {
    padding: 0 24px 32px 24px;
    /deep/ .exam-item {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
